import { XMLParser } from 'fast-xml-parser';
import { get } from 'lodash';

interface IUnit {
  '@_id': string;
  source: IUnitItem;
  target: IUnitItem;
}

interface IUnitItem {
  '#text': string;
  '@_xml': string;
}

export function xlf2json(xliffSource: string): Record<string, string> {
  const parser = new XMLParser({ ignoreAttributes: false });
  const xliffData = parser.parse(xliffSource);

  return get(xliffData, 'xliff.file.body.trans-unit', []).reduce((translation: Record<string, string>, unit: IUnit) => {
    const text = convertUnit(unit);
    translation[text.id] = text.value;

    return translation;
  }, {});
}

function convertUnit(unit: IUnit): { id: string; value: string } {
  return {
    id: unit['@_id'] || unit.source['#text'],
    value: unit.target['#text'],
  };
}
